import {useMutation} from '@apollo/react-hooks';

import type {
    DeleteBooking as DeleteBookingMutation,
    DeleteBookingVariables as DeleteBookingMutationVariables,
    GetMeeting as GetMeetingQuery,
} from 'nutshell-graphql-types';

import DELETE_BOOKING from '../mutations/delete-booking.graphql';
import GET_MEETING from '../queries/get-meeting.graphql';

export function useDeleteBooking(): (input: {
    bookingId: string;
    meetingId: string;
}) => Promise<any> {
    const [deleteBooking] = useMutation<DeleteBookingMutation, DeleteBookingMutationVariables>(
        DELETE_BOOKING
    );

    return (input: {bookingId: string; meetingId: string}) => {
        return deleteBooking({
            variables: {
                input: {
                    id: input.bookingId,
                },
            },

            update: (proxy, mutationResults) => {
                const cacheResult: GetMeetingQuery | null | undefined = proxy.readQuery({
                    query: GET_MEETING,
                    variables: {id: input.meetingId},
                });
                const deletedBooking =
                    mutationResults &&
                    mutationResults.data &&
                    mutationResults.data.bookingDelete &&
                    mutationResults.data.bookingDelete.booking;

                if (!deletedBooking) return;

                if (cacheResult) {
                    proxy.writeQuery({
                        query: GET_MEETING,
                        variables: {input},
                        data: {
                            meeting: {
                                ...cacheResult.meeting,
                                bookings: cacheResult.meeting.bookings.filter(
                                    (booking) => booking.id !== deletedBooking.id
                                ),
                            },
                        },
                    });
                }
            },
        });
    };
}
